import { Routes, Route } from "react-router-dom";
import { useIsAuthenticated } from "@azure/msal-react";
import { makeStyles } from "@fluentui/react-components";
import Layout from "./components/Layout";
import LoginPage from "./pages/LoginPage";
import PurchaseApprovalPage from "./pages/PurchaseApprovalPage";
import ApprovalDetailsPage from "./pages/ApprovalDetailsPage";
import AdminDashboardPage from "./pages/AdminDashboardPage";
import AdminSettingsPage from "./pages/AdminSettingsPage";
import MyRequestsPage from "./pages/MyRequestsPage";

const useStyles = makeStyles({
  app: {
    minHeight: "100vh",
    width: "100%",
  },
});

function App() {
  const isAuthenticated = useIsAuthenticated();
  const styles = useStyles();

  if (!isAuthenticated) {
    return <LoginPage />;
  }

  return (
    <div className={styles.app}>
      <Layout>
        <Routes>
          <Route path="/" element={<PurchaseApprovalPage />} />
          <Route path="/approval" element={<PurchaseApprovalPage />} />
          <Route path="/my-requests" element={<MyRequestsPage />} />
          <Route path="/details/:requestId" element={<ApprovalDetailsPage />} />
          {/* Targets of the Approve/Reject buttons in notification emails */}
          <Route path="/approve/:requestId" element={<ApprovalDetailsPage intent="approve" />} />
          <Route path="/reject/:requestId" element={<ApprovalDetailsPage intent="reject" />} />
          <Route path="/admin" element={<AdminDashboardPage />} />
          <Route path="/admin/settings" element={<AdminSettingsPage />} />
        </Routes>
      </Layout>
    </div>
  );
}

export default App;
